import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from 'src/app/core/helpers/auth-interceptor';

import { HomeComponent } from 'src/app/modules/main/pages/home/home.component';

import { HeaderModule } from 'src/app/core/header/header.module';
import { FooterModule } from 'src/app/core/footer/footer.module';
import { ReviewDialogComponent } from './review-dialog/review-dialog.component';
import { PhotoCarouselComponent } from 'src/app/shared/components/carousel/photo-carousel/photo-carousel.component';
import { HomeRoutingModule } from './home-routing.module';
import { NgxGalleryModule } from '@kolkov/ngx-gallery';
import { TaggedDogDialogComponent } from 'src/app/shared/components/carousel/tagged-dog-dialog/tagged-dog-dialog.component';
import { MarketingBannerCarouselComponent } from './marketing-banner-carousel/marketing-banner-carousel.component';

@NgModule({
    imports: [
        HomeRoutingModule,
        HomeComponent,
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        }
    ]
})

export class HomeModule { }
